import type { UserState } from 'utils/hooks/use-userInfo'

export const FAMILY_ROOT_ID = '901827'
export const FAMILY_HOME_URL = 'https://familia.arvore.com.br/app-v2/familia'

export function isFamilyReader(user?: Pick<UserState, 'reader'> | null) {
  const rootId = user?.reader?.root?.id

  return rootId !== undefined && rootId !== null && String(rootId) === FAMILY_ROOT_ID
}
